
<!-- 审核记录页面 -->
<template>
  <div>
    我是审核记录
  </div>
</template>

<script>
import { mapMutations } from 'vuex';
export default {
    name:'approvedPage',
    methods: {
      ...mapMutations(['changeTabPaneName'])
    
    },
    created() {
      // 改变tabName值为4
      this.changeTabPaneName('4');
    },

}
</script>

<style>

</style>